import * as React from 'react'

import { type useGlobalSearchNavigation } from '../../../../hooks/useGlobalSearchNavigation'
import { type GlobalSearchRecentItem } from '../../../../value-objects/GlobalSearchRecentItem'
import { type GlobalSearchResultItem } from '../../../../value-objects/GlobalSearchResultItem'
import { type useMutateAddGlobalSearchRecentItem } from '../../models/useMutateAddGlobalSearchRecentItem'

type NavigateFn = ReturnType<typeof useGlobalSearchNavigation>['navigate']
type AddRecentItemFn = ReturnType<
  typeof useMutateAddGlobalSearchRecentItem
>['addRecentItem']

interface IUseGlobalSearchItemActionsInput {
  onClose: () => void
  navigate: NavigateFn
  addRecentItem: AddRecentItemFn
}

interface IUseGlobalSearchItemActionsResult {
  openRecentItem: (item: GlobalSearchRecentItem) => void
  openResultItem: (item: GlobalSearchResultItem) => void
}

export const useGlobalSearchItemActions = ({
  onClose,
  navigate,
  addRecentItem,
}: IUseGlobalSearchItemActionsInput): IUseGlobalSearchItemActionsResult => {
  const openRecentItem = React.useCallback(
    (item: GlobalSearchRecentItem) => {
      const status = 'status' in item.metadata ? item.metadata.status : null
      addRecentItem({
        type: item.type,
        uuid: item.uuid,
        id: item.id,
        label: item.label,
        metadata: item.metadata,
      })
      onClose()
      navigate({ type: item.type, uuid: item.uuid, id: item.id, status })
    },
    [navigate, addRecentItem, onClose]
  )

  const openResultItem = React.useCallback(
    (item: GlobalSearchResultItem) => {
      const status = 'status' in item.metadata ? item.metadata.status : null
      addRecentItem({
        type: item.type,
        uuid: item.uuid,
        id: item.id,
        label: item.label,
        metadata: item.metadata,
      })
      onClose()
      navigate({ type: item.type, uuid: item.uuid, id: item.id, status })
    },
    [navigate, addRecentItem, onClose]
  )

  return {
    openRecentItem,
    openResultItem,
  }
}
